import React from 'react';

interface SvgFullscreenPreviewProps {
  readonly svgContent: string;
  readonly onClose: () => void;
}

const SvgFullscreenPreview: React.FC<SvgFullscreenPreviewProps> = ({
  svgContent,
  onClose,
}) => {
  return (
    <div className="ai-svg-fullscreen-backdrop" onClick={onClose}>
      <div
        className="ai-svg-fullscreen-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="ai-svg-fullscreen-header">
          <span className="ai-svg-fullscreen-title">SVG 预览</span>
          <button
            className="ai-svg-ghost-button-light"
            onClick={onClose}
          >
            ✕ 关闭
          </button>
        </div>
        <div className="ai-svg-fullscreen-content">
          <div dangerouslySetInnerHTML={{ __html: svgContent }} />
        </div>
      </div>
    </div>
  );
};

export default SvgFullscreenPreview;